// Alte datien löschen 

import AlertHandler from "../../../assets/js/modules/alertHandler";

;(function(){
    if(location.hostname==='localhost'||location.hostname==='127.0.0.1'){
      const fake={ coords:{ latitude:47.117943, longitude:10.602762, accuracy:5 } };
      navigator.geolocation.getCurrentPosition=(succ,err,opt)=>
        setTimeout(()=>succ(fake),0);
      navigator.geolocation.watchPosition=(succ,err,opt)=>{
        setTimeout(()=>succ(fake),0);
        return 1;
      };
    }
})();


const startBtn = document.getElementById('startBtn');
const stopBtn = document.getElementById('stopBtn');


let map = null;
let totalDistance = 0;
let allPoints = [];


function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


// Abschluss: Route speichern
export function closeRoute () {
    const closeRouteBtn = document.getElementById('close-route-btn');
    if(!closeRouteBtn) return;
    const accessToken = getCookie('drfToken');
    if(!accessToken) return;
    closeRouteBtn.addEventListener('click', () => {
        const routeId = closeRouteBtn.dataset.routeId;  
        fetch(`/api/gpstracking/routes/${routeId}/close-route/`, { 
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${accessToken}`
            },
        })
        .then(response => {
            if (!response.ok) throw response;
            return response.json();
          })
        .then(data => {
            AlertHandler.showAlert(data.message, 'success');
            if(data.is_closed){
                hiddenButton()
            }
        })
        .catch(err => {
            if (err.json) {
              err.json().then(e => {
                AlertHandler.showAlert(e.error || 'Fehler beim Schließen', 'error');
              });
            } else {
              AlertHandler.showAlert('Netzwerkfehler', 'error');
            }
            console.error(err);
        });
      });

}

// Routen-Darstellung + Distanz-Berechnung
function displayRoute(route) {
    const path = route.gps_data.map(p => [
        parseFloat(p.latitude),
        parseFloat(p.longitude)
    ]);

    allPoints = allPoints.concat(path);
    if (!map) return 0;

    L.polyline(path, { color: 'red' }).addTo(map);
    if (path.length > 0) {
        map.fitBounds(L.latLngBounds(path));
    }

    let distance = 0;
    for (let i = 1; i < path.length; i++) {
        distance += map.distance(path[i - 1], path[i]);
    }

    if (path.length > 0) {
        L.marker(path[0]).addTo(map).bindPopup(
            `Start: ${route.name}<br>Länge: ${(distance / 1000).toFixed(2)} km`
        );
        L.marker(path[path.length - 1]).addTo(map).bindPopup(
            `Ende: ${route.name}`
        );
    }

    return distance; 
}

// Gesamtlänge anzeigen, nutzt "totalDistance"
function displayTotalDistance() {
    const distanceDiv = document.createElement('div');
    distanceDiv.style.padding = '10px';
    distanceDiv.style.backgroundColor = '#f0f0f0';
    distanceDiv.style.marginTop = '10px';
    distanceDiv.textContent = `Gesamtlänge aller Routen: ${(totalDistance / 1000).toFixed(2)} km`;
    document.getElementById('mapRouteView').after(distanceDiv);
}

// Fläche-Button
function addCalculateAreaButton() {
    const button = document.createElement('button');
    button.textContent = 'Fläche berechnen';
    button.style.marginTop = '10px';
    button.classList = 'btn btn-primary';
    button.onclick = calculateAndDisplayArea;
    document.getElementById('mapRouteView').after(button);
}


// Fläche berechnen, nutzt "allPoints" und "map"
function calculateAndDisplayArea() {
    if (allPoints.length < 3) {
        alert('Nicht genug Punkte für eine Flächenberechnung');
        return;
    }
    const existingAreaDiv = document.getElementById('area-calculation');
    if (existingAreaDiv) existingAreaDiv.remove();

    const closedPolygon = [...allPoints, allPoints[0]];
    const polygon = L.polygon(closedPolygon, { color: 'blue', fillOpacity: 0.1 }).addTo(map);

    const latlngs = polygon.getLatLngs()[0];
    let area = 0;
    for (let i = 0; i < latlngs.length - 1; i++) {
        const p1 = latlngs[i], p2 = latlngs[i + 1];
        area += (p2.lng - p1.lng) * (2 + Math.sin(p1.lat * Math.PI / 180) + Math.sin(p2.lat * Math.PI / 180));
    }
    area = Math.abs(area * 6378137 * 6378137 / 2);
    let areaInHectares = Math.round(area / 10000);

    let formattedArea;
    if (areaInHectares >= 1000000) {
        formattedArea = (areaInHectares / 1000000).toFixed(2) + ' Mio.';
    } else if (areaInHectares >= 1000) {
        formattedArea = (areaInHectares / 1000).toFixed(2) + ' Tsd.';
    } else {
        formattedArea = areaInHectares.toString();
    }

    const areaDiv = document.createElement('div');
    areaDiv.id = 'area-calculation';
    areaDiv.style.padding = '10px';
    areaDiv.style.backgroundColor = '#e6f7ff';
    areaDiv.style.marginTop = '10px';
    areaDiv.textContent = `Ungefähre Fläche: ${formattedArea} Hektar`;
    document.getElementById('mapRouteView').after(areaDiv);
}

// Fehler ausgeben
function displayError(message) {
    const errorDiv = document.createElement('div');
    errorDiv.style.color = 'red';
    errorDiv.style.padding = '10px';
    errorDiv.textContent = `Fehler: ${message}`;
    document.getElementById('mapRouteView').appendChild(errorDiv);
}




export function GPSTrekkingDeatile () {
    // Buttons
    if (!startBtn || !stopBtn) return;
    startBtn.setAttribute('data-route-id', DetailRouteId);
    startBtn.onclick = () => startTracking(DetailRouteId);
    stopBtn.onclick  = () => stopTracking();

    // Karte initialisieren
    map = L.map('mapRouteView', {
        center: [47.5, 14.0],
        zoom: 20,
        minZoom: 1,
        maxZoom: 20
    });

    // OSM-Layer (MapTiler)
    L.tileLayer('https://api.maptiler.com/maps/openstreetmap/{z}/{x}/{y}.jpg?key=msAWRru7q043rqx3RU5P', {
        attribution: '&copy; <a href="https://www.maptiler.com/">MapTiler</a> ' +
                   '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        minZoom: 1,
        maxZoom: 20
    }).addTo(map);


    const mapEl    = document.getElementById('mapRouteView');
    const userName = mapEl.dataset.username || 'User';
    const nameIcon = L.divIcon({
        html: `<span class="user-name-icon">${userName}</span>`,
        className: 'leaflet-user-name-icon',
        iconSize: [(userName.length * 8) + 10, 24],
        iconAnchor: [((userName.length * 8) + 10) / 2, 24]
    });

    const opts = {
        enableHighAccuracy: true,
        timeout:       30000,
        maximumAge:    60000
    };

    const onSuccess = ({ coords: { latitude, longitude } }) => {
        map.setView([latitude, longitude], 16);
        L.marker([latitude, longitude], { icon: nameIcon })
            .addTo(map)
            .bindPopup(userName)
            .openPopup();
    };

    const onError = err => {
        if (err.code === err.POSITION_UNAVAILABLE) {
            navigator.geolocation.watchPosition(onSuccess, onError, opts);
        }
    };
    navigator.geolocation.getCurrentPosition(onSuccess, onError, opts);


    // Layer-Control Update
    let schlaegeLayer = null;
    const savedFeatures = [];
    map.on('moveend', () => {
        updateSchlaege();
    });

    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;

    let isFirstLoad = true;
    function updateSchlaege() {
        const bounds = map.getBounds();
        const bbox = bounds.toBBoxString();
        fetch(`/gpstracking/api/schlaege/?bbox=${bbox}`)
        .then(r => r.json())
        .then(geojson => {
            if (schlaegeLayer) map.removeLayer(schlaegeLayer);
            schlaegeLayer = L.geoJSON(geojson, {
                style: () => ({ weight: 1 }),
                onEachFeature: (feat, layer) => {
                    const area = feat.properties.SL_FLAECHE_BRUTTO_HA?.toFixed(2) || '?';
                    const usage = feat.properties.SNAR_BEZEICHNUNG || 'unbekannt';
                    const content = `
                    <div>
                        <strong>Fläche:</strong> ${area} ha<br/>
                        <strong>Nutzung:</strong> ${usage}<br/>
                        <button id="saveFeatureBtn" class="btn btn-primary btn-sm mt-1 save-feature-btn">Speichern</button>
                    </div>
                    `;
                    layer.bindPopup(content);
                    layer.on('popupopen', e => {
                        const btn = e.popup._contentNode.querySelector('.save-feature-btn');
                        btn.addEventListener('click', () => {
                            // Holt den Layer
                            const layerGeoJSON = layer.toGeoJSON();
                            const { geometry } = layerGeoJSON;
                            // Eintrag speichern, Duplikate vermeiden
                            const key = `${usage}|${area}`;
                            if (!savedFeatures.find(f => f.key === key)) {
                                fetch(`/gpstracking/orders/update/${odersId}/`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-CSRFToken': csrfToken
                                    },
                                    body: JSON.stringify({ usage, area, geometry })
                                })
                                .then(response => response.json())
                                .then(data => {
                                    if(data.success){
                                        AlertHandler.showAlert(data.message, 'success');
                                        getFetchGeometry();
                                    }
                                })
                                .catch(error => {
                                    console.error('Fehler beim Senden:', error);
                                });
                            }
                        });
                    });
                }
                }).addTo(map);
                if (isFirstLoad) {
                    const layerBounds = schlaegeLayer.getBounds();
                    if (layerBounds.isValid()) {
                      map.fitBounds(layerBounds, { padding: [20, 20] });
                      isFirstLoad = false;
                    }
                }
        })
        .catch(err => console.error(err));
    }

    updateSchlaege();

    // Zeigt den gespeicherten Layer an, der im Auftrag gespeichert ist.
    function getFetchGeometry(){
        fetch(`/gpstracking/orders/update/${odersId}/`, {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(response => {
            if (!response.ok) {
                return response.text().then(txt => {
                    throw new Error(`HTTP ${r.status}, ${txt}`);
                });
            }
            return response.json();
        })
        .then(data => {
            const savedLayer = L.geoJSON(data, {
                style: { color: 'red', weight: 2 }
            }).addTo(map);
        })
        .catch(err => {
            console.error('Fehler beim Laden der Routendaten:', err);
            displayError(err.message);
        });
    }
    getFetchGeometry();

    // Lädt die Pfade der gespeicherten Route.
    fetch(`/gpstracking/detail-template-route/${DetailRouteId}/`, {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(r => {
        if (!r.ok) {
            return r.text().then(txt => {
                throw new Error(`HTTP ${r.status}, ${txt}`);
            });
        }
        return r.json();
    })
    .then(data => {
        data.forEach(route => {
            const dist = displayRoute(route);
            totalDistance += dist;
        });
        if(data[0].is_closed){
            hiddenButton()
        }
        //displayTotalDistance();
        //addCalculateAreaButton();
    })
    .catch(err => {
        console.error('Fehler beim Laden der Routendaten:', err);
        displayError(err.message);
    });
};

// Route abgeschlossen, dann Buttons sperren
function hiddenButton(){
    const buttonIDs = ['startBtn', 'stopBtn', 'close-route-btn', 'saveFeatureBtn'];
    buttonIDs.forEach(id => {
        const btn = document.getElementById(id);
        if (btn) {
          btn.disabled = true;
          btn.onclick = (e) => e.preventDefault();
        }
    });
}





let socket = null;
let watchID = null;
let trackingActive = false;
let sendInterval = null;
let lastPosition = null;
let wakeLock = null;
let otherMarker = null;
const statusElement = document.getElementById('status');


function preventPageLeave(event) {
    if (trackingActive) {
        event.preventDefault();
        event.returnValue = '';
        return ''; 
    }
}

function positionHasChanged(newLat, newLon) {
    if (!lastPosition) return true;
    const threshold = 0.0001;
    return Math.abs(newLat - lastPosition.latitude) > threshold ||
           Math.abs(newLon - lastPosition.longitude) > threshold;
}


async function requestWakeLock() {
    try {
        wakeLock = await navigator.wakeLock.request('screen');
        statusElement.textContent = 'Tracking aktiv. Handy bleibt wach.';
        console.log('Wake Lock aktiviert.');
        wakeLock.addEventListener('release', () => {
            console.log('Wake Lock freigegeben.');
        });
    } catch (err) {
        console.error(`${err.name}, ${err.message}`);
    }
}

async function releaseWakeLock() {
    if (wakeLock !== null) {
        await wakeLock.release();
        wakeLock = null;
        console.log('Wake Lock wurde manuell freigegeben.');
    }
}


const config = {
    local: {
        websocketURL: 'ws://127.0.0.1:8000/ws/track/'
    },
    live: {
        websocketURL: 'wss://agriflow.pixel-west.com/ws/track/'
    }
};

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const websocketURL = isLocal ? config.local.websocketURL : config.live.websocketURL;


function startTracking(id) {
    requestWakeLock();
    if (socket !== null) {
        console.log('WebSocket bereits verbunden.');
        return;
    }

    socket = new WebSocket(websocketURL);
        socket.onopen = function() {
            console.log('WebSocket verbunden.');
            trackingActive = true;
            window.onbeforeunload = preventPageLeave;

            if ('geolocation' in navigator) {
                watchID = navigator.geolocation.watchPosition(function(position) {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    if (positionHasChanged(latitude, longitude)) {                        
                        if (!lastPosition || positionHasChanged(latitude, longitude)) {
                            console.log('Neue GPS-Position:', latitude, longitude);
                            lastPosition = { latitude, longitude };
                            if (socket.readyState === WebSocket.OPEN) {
                                socket.send(JSON.stringify({
                                    'route_id': id,
                                    'latitude': latitude,
                                    'longitude': longitude
                                }));
                                console.log('GPS-Daten gesendet:', latitude, longitude);
                            }
                        }
                    }
                }, function(error) {}, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                });
            }

            socket.onmessage = event => {
                const data = JSON.parse(event.data);
                const lat  = data.latitude;
                const lon  = data.longitude;
                if (otherMarker) {
                    otherMarker.setLatLng([lat, lon]);
                } else {
                    otherMarker = L.marker([lat, lon])
                        .addTo(map)
                        .bindPopup('Andere Person hier');
                }
            };

            socket.addEventListener('message', function(event) {
                const data = JSON.parse(event.data);
                console.log('Empfangene GPS-Daten:', data.latitude, data.longitude);
            });
        };
        socket.onmessage = function(event) {
            const data = JSON.parse(event.data);
            console.log('Empfangene GPS-Daten:', data.latitude, data.longitude);
        };
        socket.onerror = function() {
            console.error('WebSocket Fehler.');
        };
}


function stopTracking() {
    releaseWakeLock();
        console.log('Tracking stoppen');
        
        if (watchID !== null) {
            navigator.geolocation.clearWatch(watchID);
            watchID = null;
        }
        
        if (sendInterval !== null) {
            clearInterval(sendInterval);
            sendInterval = null;
        }
    
        if (socket !== null) {
            if (socket.readyState === WebSocket.OPEN) {
                socket.close();
            }
            socket = null;
        }
    
        trackingActive = false;
        window.onbeforeunload = null; 
        lastPosition = null;
        otherMarker = null;
        statusElement.textContent = '';
}